export const headerHeightLg = '107px'
export const headerHeightMd = '70px'
export const headerHeight = '60px'